import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getInternalFundTransferReport = createAsyncThunk(
  "app/getInternalFundTransferReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/fund-transfer/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);
